var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{ref:"editor",style:(_vm.currentStyle),attrs:{"src":_vm.workspaceUrl+'/proxy/?tkn=yourTokenHere&workspace=/home/workspace/.vscode/project.code-workspace'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }